import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Nav, Tab, Tabs } from 'react-bootstrap';

import { WmcContext } from '../../../../context/WmcContext';
import { DATA_TYPE, DT1, DT2, LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY } from '../../../../api/AxiosApi';
// import WmsTab3Content from './wmsTabs/WmsTab3Content';
import WmsHeader from '../../../../components/general/WmsHeader';

import { NavLink, useLocation } from 'react-router-dom';

import PlantCurve from './plantTabs/PlantCurve';
import PlantLogTabs from './plantLogTabs/PlantLogTabs';
import TopHeader from '../../../../components/general/TopHeader';
import DailyCurtailment from './dailyCurtailment/DailyCurtailment';
import Outage from './outage/Outage';
import { AuthenticationContext } from '../../../../context/AuthenticationContext';
import CurtailmentData from './CurtailmentData/CurtailmentData';

export default function PlantPowerCurve() {
    const { palette, typography, breakpoints, shape: { }, spacing } = useTheme()
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const matches = useMediaQuery(breakpoints.up('lg'));
    const [key, setKey] = useState('Plant Power Curve');
    const location = useLocation();
    // console.log('NAMEOFPATH', location.pathname);
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }
    return (
        <>
            <CssBaseline />
            {/* <WmsHeader /> */}
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* Plant-power-curve */}
                    </NavLink>
                    {/* <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {location.pathname}
                    </NavLink> */}
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Plant Power Curve" title="Plant Power Curve">
                        <PlantCurve />
                    </Tab>

                    <Tab eventKey="Plant Power Log" title="Plant Power Log">
                        <PlantLogTabs />
                    </Tab>


                    {LoggedInUserInfo?.MNU_CURT_DAILY === "1" && (
                        <Tab eventKey="Curtailment Summary" title="Curtailment Summary">
                            <DailyCurtailment />
                        </Tab>
                    )}

                    {LoggedInUserInfo?.MNU_CURT_DAILY === "1" && (
                        <Tab eventKey="Day Wise Curtailment" title="Day Wise Curtailment">
                            <CurtailmentData />
                        </Tab>
                    )}

                    {LoggedInUserInfo?.TAB_OUTAGE === "1" && (
                        <Tab eventKey="Outage" title="Outage">
                            <Outage />
                        </Tab>
                    )}




                </Tabs>
            </Box>
        </>

    )
}
